import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "guest-details mt-3" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = { class: "btn-stripped text-danger" }
const _hoisted_4 = { class: "guest-details__tabs mt-3" }
const _hoisted_5 = { class: "p-tabview-title" }
const _hoisted_6 = { class: "p-tabview-title" }
const _hoisted_7 = { class: "p-tabview-title" }
const _hoisted_8 = { class: "p-tabview-title" }
const _hoisted_9 = { class: "d-flex align-items-center mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_ContactTab = _resolveComponent("ContactTab")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_GateAccessTab = _resolveComponent("GateAccessTab")
  const _component_BadgeTab = _resolveComponent("BadgeTab")
  const _component_CodeTab = _resolveComponent("CodeTab")
  const _component_TabView = _resolveComponent("TabView")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("h4", null, _toDisplayString(_ctx.guestSelected.description), 1),
        _createVNode(_component_ElDropdown, {
          class: "ml-auto",
          trigger: "click",
          placement: "bottom-end",
          "popper-class": "el-dropdown__popper el-dropdown--context"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_ElDropdownMenu, { style: {"width":"200px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleDeleteGuestConfirm }, {
                  default: _withCtx(() => [
                    _createVNode("button", _hoisted_3, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Button, { class: "p-button-text p-button-secondary p-1" }, {
              default: _withCtx(() => [
                _createVNode(_component_InlineSvgScoped, {
                  src: 
                            require('@/assets/images/icons/icon-ellipsis-v.svg')
                        ,
                  "aria-label": "icon-ellipsis-v"
                }, null, 8, ["src"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_TabView, null, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("AppResourceEP.ContactTab")), 1),
                (_ctx.guestContactEdited || _ctx.errorContact)
                  ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                      key: 0,
                      class: { 'has-error': _ctx.errorContact },
                      src: 
                                require('@/assets/images/entrancePlants/tab-edited.svg')
                            ,
                      "aria-label": "tab-edited"
                    }, null, 8, ["class", "src"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_ContactTab, {
                  key: _ctx.updateGuesttKey,
                  editingGuest: _ctx.editedGuest,
                  onContactEdited: _ctx.handleContactEdited,
                  onErrorContact: _ctx.handleErrorContact
                }, null, 8, ["editingGuest", "onContactEdited", "onErrorContact"])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createVNode("span", _hoisted_6, _toDisplayString(_ctx.$t("AppResourceEP.GateAccessTab")), 1),
                (_ctx.guestGateAccessEdited || _ctx.errorGateAccess)
                  ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                      key: 0,
                      class: { 'has-error': _ctx.errorGateAccess },
                      src: 
                                require('@/assets/images/entrancePlants/tab-edited.svg')
                            ,
                      "aria-label": "tab-edited"
                    }, null, 8, ["class", "src"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_GateAccessTab, {
                  key: _ctx.updateGuesttKey,
                  editingGuest: _ctx.editedGuest,
                  timesSlotsWithValidation: _ctx.timesSlots,
                  gates: _ctx.gates,
                  onGateAccessEdited: _ctx.handleGateAccesEdited,
                  onErrorGateAccess: _ctx.handleErrorGateAccess
                }, null, 8, ["editingGuest", "timesSlotsWithValidation", "gates", "onGateAccessEdited", "onErrorGateAccess"])
              ]),
              _: 1
            }),
            _createVNode(_component_TabPanel, {
              disabled: _ctx.guestSelected.isOneTimeGuest
            }, {
              header: _withCtx(() => [
                _createVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("AppResourceEP.BadgeTab")), 1),
                (_ctx.guestBadgeEdited || _ctx.errorBadge)
                  ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                      key: 0,
                      class: { 'has-error': _ctx.errorBadge },
                      src: 
                                require('@/assets/images/entrancePlants/tab-edited.svg')
                            ,
                      "aria-label": "tab-edited"
                    }, null, 8, ["class", "src"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_BadgeTab, {
                  key: _ctx.updateGuesttKey,
                  editingGuest: _ctx.editedGuest,
                  onBadgeEdited: _ctx.handleBadgeEdited,
                  onErrorBadge: _ctx.handleErrorBadge
                }, null, 8, ["editingGuest", "onBadgeEdited", "onErrorBadge"])
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_TabPanel, null, {
              header: _withCtx(() => [
                _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("AppResourceEP.CodeTab")), 1),
                (_ctx.guestKeyCodeEdited || _ctx.errorKeyCode)
                  ? (_openBlock(), _createBlock(_component_InlineSvgScoped, {
                      key: 0,
                      class: ["ml-auto", { 'has-error': _ctx.errorKeyCode }],
                      src: 
                                require('@/assets/images/entrancePlants/tab-edited.svg')
                            ,
                      "aria-label": "tab-edited"
                    }, null, 8, ["class", "src"]))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(_component_CodeTab, {
                  updateGuesttKey: _ctx.updateGuesttKey,
                  editingGuest: _ctx.editedGuest,
                  onKeyCodeEdited: _ctx.handleKeyCodeEdited,
                  onErrorKeyCode: _ctx.handleErrorKeyCode
                }, null, 8, ["updateGuesttKey", "editingGuest", "onKeyCodeEdited", "onErrorKeyCode"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode(_component_Button, {
          class: "ml-auto p-button-rounded p-button-raised p-button--m",
          onClick: _ctx.handleSaveEditedGuest,
          disabled: !_ctx.guestWasEdited
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("SaveChanges")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteGuestConfirm,
      title: _ctx.$t('AppResourceEP.GateGuestDeletionPopupTitle'),
      message: _ctx.$t('AppResourceEP.GateGuestDeletionPopupMessage'),
      onHideDialog: _ctx.toggleDeleteGuestConfirm,
      onConfirm: _ctx.handleDeleteGuest
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"])
  ], 64))
}